import {Module} from "vuex";

const CountModule: Module<any, any> = {
    namespaced: true,
    state: {
        count: 15,
    },
    getters: {
      getCount(state: any){
          return state.count;
      }
    },
    mutations: {
        increment(state: any){
            state.count++;
        }
    },
    actions:{
        async aIncrement(context: any){
            context.commit('increment');
        }
    }
}

export default CountModule;

